import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";

const ReportsPurchaseOrdersListDashboard = lazyLoader(
  () =>
    import(
      "Containers/Reports/ReportsInnerPages/ReportsPurchaseOrderList/ReportsPurchaseOrderListDashboard/ReportsPurchaseOrderListDashboard"
    )
);
export const ReportsPurchaseOrdersList = () => {
  return (
    <Layout>
      <ReportsPurchaseOrdersListDashboard />
    </Layout>
  );
};
